import { getSites, getAssets, getComponents } from '@entities'
import { useAsyncResource } from '@hooks'
import { buildDraftCatalog } from './mfsDraft.model'

export function useMfsCatalog (companyId) {
  return useAsyncResource(
    async () => {
      const [sites, assets, components] = await Promise.all([
        getSites(companyId),
        getAssets(companyId),
        getComponents({ companyId })
      ])
      return buildDraftCatalog(companyId, sites, assets, components)
    },
    [companyId],
    { initialData: null, enabled: Boolean(companyId) }
  )
}
